module.exports = ".kan-partner-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/partner-dialog/component.scss
// module id = ./src/modules/admin/dialogs/partner-dialog/component.scss
// module chunks = main